const getTemplateKey = state => state.templateKey;

const getButtonTextContinue = state => {
  const [agreement] = state.agreements;
  if (agreement) {
    return agreement.buttonTextContinue;
  }
  return '';
};

const getDisplayFinePrint = state => {
  const [agreement] = state.agreements;
  if (agreement) {
    return agreement.displayFinePrint;
  }
  return '';
};

const getIsAgreementEmpty = state => state.agreements.length === 0;

export default {
  getTemplateKey,
  getButtonTextContinue,
  getDisplayFinePrint,
  getIsAgreementEmpty,
};
